import { render, staticRenderFns } from "./td-marginOpt.vue?vue&type=template&id=842e6262&"
import script from "./td-marginOpt.vue?vue&type=script&lang=js&"
export * from "./td-marginOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-marginOpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports